import React, { useState, useEffect } from 'react'
import { getBreConfigData, saveUpdateBreconfigData } from '../../../AdminActionCreator.component'
import Loader from '../../../../../presentationals/Loader/Loader.component'

export default function ViewSection({ LeadData, scoreDetail, viewType, handleView }) {
    const [loader, setLoader] = useState(false)
    const [apiData, setapiData] = useState({})
    const [updatedData, setUpdatedData] = useState([])
    const InputStyle = {
        border: "1px solid #1D3557",
        borderRadius: '8px',
        padding: "6px",
        width: "100%"
    }

    useEffect(() => {
        if (scoreDetail && scoreDetail?.length > 0) {
            setUpdatedData(scoreDetail)
        }
        if (viewType === "edit") {
            getBreConfigDataFunction()
        }
    }, [scoreDetail, viewType])

    const handlechange = (e, field, index) => {

        let newValue = e.target.value;


        if (field === "weightagePercentage") {
            // const newWeightage = newValue?.replace("%", "") || "";
            if (Number(field) > 100) {
                return
            } else {
                newValue = field + "%";
            }
        } else if (field === "score") {
            if (Number(newValue) > 100) {
                return
            } else {
                newValue = newValue;
            }
        }

        setUpdatedData(prevData => {
            const updatedArray = [...prevData];
            updatedArray[index] = { ...updatedArray[index], [field]: newValue };
            return updatedArray;
        });
    }


    const handleSave = () => {
        console.log("updatedDataupdatedData", updatedData)
        if (viewType === "edit") {
            setLoader(true)
            saveUpdateBreconfigData(LeadData?.userId, updatedData, (callback) => {
                console.log("callback", callback)
                if (callback == "success") {
                    handleView("view")
                } else {

                }
                setLoader(false)
            })

        }
    }


    const getBreConfigDataFunction = () => {
        setLoader(true)
        getBreConfigData((callback) => {
            setLoader(false)

            setapiData(callback)
        })
    }


    return (
        <>
            <div className="" style={{ padding: '10px' }}>
                {
                    loader ?
                        <Loader /> : ''
                }
                <div style={{ border: '1px solid #eee', borderRadius: '10px' }}>
                    <div style={{ background: '#DBE9FF', padding: '10px', borderTopLeftRadius: '10px', borderTopRightRadius: '10px', display: 'flex', justifyContent: 'space-between' }}>
                        <div>
                            <b>BRE Scoring</b>
                        </div>
                        <div>
                            {
                                viewType === "edit" ?
                                    <i class="fa fa-eye" aria-hidden="true" onClick={() => handleView("view")} style={{cursor:'pointer'}}></i>
                                    :
                                    <i class="fa fa-pencil-square-o" aria-hidden="true" onClick={() => handleView("edit")} style={{cursor:'pointer'}}></i>
                            }
                        </div>
                    </div>
                    <div className="" style={{ overflowY: 'auto', height: '200px', padding: '0px 10px',margin:'10px 0' }}>
                        <table className="scoring-table" style={{ position: 'relative', width: '100%' }}>
                            <thead style={{ background: '#02534f', color: '#fff', position: 'sticky', top: '0' }}>
                                <tr>
                                    <td style={{ border: "1px solid #eee", whiteSpace: 'nowrap', textAlign: 'center', padding: '10px' }}><b>Policy Parameters</b></td>
                                    <td style={{ border: "1px solid #eee", textAlign: 'center', whiteSpace: 'nowrap', padding: '10px' }}><b>Score Parameters</b></td>
                                    <td style={{ border: "1px solid #eee", textAlign: 'center', whiteSpace: 'nowrap', padding: '10px' }}><b>Weightage (in %)</b></td>
                                    <td style={{ border: "1px solid #eee", textAlign: 'center', whiteSpace: 'nowrap', padding: '10px', width: '200px' }}><b>Score</b></td>
                                </tr>
                            </thead>
                            {
                                updatedData && updatedData?.length > 0 ?
                                    updatedData?.map((value, index) => {

                                        // const newWeightage = value?.weightage?.replace("%", "") || "";
                                        const arr = value?.["policyParameter"] == "OEM Name" ? apiData?.["OEM Name"] : value?.["policyParameter"] == "Dealer Name" ? apiData?.["Dealer Name"] : value?.["policyParameter"] == "Gender" ? apiData?.Gender : value?.["policyParameter"] == "Ownership Status" ? apiData?.["Ownership Status"] : value?.["policyParameter"] == "FOIR" ? apiData?.["FOIR"] : [];
                                        return (
                                            <tr key={index}>
                                                <td style={{ border: "1px solid #eee", whiteSpace: 'nowrap', padding: '10px' }}>
                                                    {value?.["policyParameter"] || "-"}
                                                </td>
                                                <td style={{ border: "1px solid #eee", whiteSpace: 'nowrap', textAlign: 'center', padding: '10px' }}>
                                                    {
                                                        viewType === "edit" && value?.["policyParameter"] !== "Age" ?
                                                            value?.["policyParameter"] == "OEM Name" || value?.["policyParameter"] == "Gender" || value?.["policyParameter"] == "Dealer Name" || value?.["policyParameter"] == "Ownership Status" || value?.["policyParameter"] == "FOIR" ?
                                                                <select value={value?.["scoreParameter"]} name={`${value?.["policyParameter"]}-scoreParameter`} style={InputStyle} onChange={(e) => handlechange(e, "scoreParameter", index)}>
                                                                    <option value="">Select</option>
                                                                    {
                                                                        arr?.map((value, index) => {
                                                                            return (
                                                                                <option key={index} value={value}>{value}</option>
                                                                            )
                                                                        })

                                                                    }
                                                                </select>
                                                                :
                                                                <input type='text' value={value?.["scoreParameter"]} name={`${value?.["policyParameter"]}-scoreParameter`} style={InputStyle} onChange={(e) => handlechange(e, "scoreParameter", index)} />
                                                            :
                                                            value?.["scoreParameter"] || "-"
                                                    }
                                                </td>
                                                <td style={{ border: "1px solid #eee", whiteSpace: 'nowrap', textAlign: 'center', padding: '10px' }}>
                                                    {
                                                        viewType === "edit" && value?.["policyParameter"] !== "Age" ?
                                                            <input type='number' value={value?.weightagePercentage} name={`${value?.["policyParameter"]}-weightagePercentage`} min={0} max={100} style={InputStyle} onChange={(e) => handlechange(e, "weightagePercentage", index)} />
                                                            :
                                                            value?.weightagePercentage || "-"
                                                    }

                                                </td>
                                                <td style={{ border: "1px solid #eee", whiteSpace: 'nowrap', textAlign: 'center', padding: '10px' }}>
                                                    {
                                                        viewType === "edit" && value?.["policyParameter"] !== "Age" ?
                                                            <input type='number' value={value?.score} name={`${value?.["policyParameter"]}-score`} min={0} max={100} style={InputStyle} onChange={(e) => handlechange(e, "score", index)} />
                                                            :
                                                            value?.score || "-"
                                                    }

                                                </td>
                                            </tr>
                                        )
                                    })
                                    : ''}



                        </table>
                    </div>
                </div>
                {
                    viewType === "edit" ?
                        <div style={{ marginTop: '20px', textAlign: 'center' }}>
                            <button className="btn-primary" style={{ borderRadius: '8px', border: '1px solid #064254', padding: '7px 15px' }} onClick={() => handleSave()}>Save</button>
                        </div>
                        : ''}
            </div>
        </>
    )
}
